import qs from 'qs'

export const isTouchDevice = 'ontouchstart' in document.documentElement

export const isIos =
  /iPad|iPhone|iPod/.test(navigator.platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)

export const generateUrl = (form, data = {}) => {
  let params = data

  if (data instanceof FormData === true) {
    params = {}

    data.forEach((value, key) => (params[key] = value))
  }

  const query = qs.stringify(params, { filter: (_, value) => value || undefined })
  const queryStr = query ? `?${query}` : ''

  return `${form.action}${queryStr}`
}

export const trackGoogleAnalytics = (event) => {
  if (window.dataLayer) {
    window.dataLayer.push(event)
  }
}
